module.exports = __webpack_public_path__ + "static/media/redBingoBall.7db4958e.png";